module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAFBAMAAAA595h8AAAAElBMVEUkJiYkJiYkJiYkJiYkJiYkJiZdPvqbAAAABXRSTlPA87sgH24qb4UAAAAdSURBVAjXY3AIRQEBBgyqoaiAgUEUTUQAUw2mOQCeEBota7woxgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme_black/minus.png
// module id = 1knL
// module chunks = 1